import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentSpaceUserAccessUser on User {
    id
    firstName
    lastName
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSpaceUserAccessUserFragment,
  ents.extra.space.User
>({
  id: transformers.PASS_THROUGH,
  name: ({ firstName, lastName }) =>
    firstName && lastName
      ? `${firstName} ${lastName}`
      : (firstName ?? lastName ?? 'Unknown User'),
})
